<template>
  <div class="autostation">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">Auto-Station</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <v-img contain :src="require('@/assets/img_sub_prod_autostation.svg')" max-height="695"></v-img>
          <v-row class="align-stretch mt-8">
            <v-col cols="12" class="d-flex align-stretch">

              <v-card width="100%" class="px-4 pt-8 pb-10" outlined>
                <v-row class="align-stretch">
                  <v-col cols="12">
                    <h5 class="text-h6 text-md-h5 font-weight-bold">Auto-Station Architecture</h5>
                    <ul class="list-type02 mt-2">
                      <li>Auto-Station는 다종다양한 자동화도구를 단위 Task로 구성하여 iBPMS기반으로 용도에 맞게 조합, 적용함으로써 기업의 종단간(End to  End) 업무 프로세스를 자동화하고 실시간으로 모니터링 가능함.</li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card>

            </v-col>
          </v-row>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'autostation',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".autostation .sub-body-title", {
      scrollTrigger: {
        trigger: ".autostation .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".autostation .sub-body-content", {
      scrollTrigger: {
        trigger: ".autostation .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>